/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { resBreak } from '@/utils/resBreak';
import { StackProps, SxProps } from '@mui/material';

export const productDetailsAddToCartStack = (standalone?: boolean): StackProps => ({
	direction: resBreak({ mobile: 'column', tablet: 'row' }),
	spacing: 1,
	justifyContent: resBreak({ mobile: 'center', tablet: standalone ? 'flex-end' : 'flex-start' }),
	width:'100%'
});

export const addtocartbuttonSX:SxProps ={
	backgroundColor:'#53aa28',
	width:'100%',
	fontWeight : 'fontWeightBold',
	fontSize : '20px',
	'&:hover':{
        backgroundColor:'#3b7b1b',
    },
	columnGap:2,
	alignItems:'center'
}

export const BrandAndSeriesLinksSX:SxProps ={
		textDecoration:'underline'
}

export const basketIconPDPSX:SxProps ={
	fontSize:20,
	color: '#fff'
}